import {Route} from 'react-router-dom';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <Route key="/business/showcase/bags" element={<ShowocaseLayout />}>
    <Route path="business/showcase/bags" element={<AsyncPage />} />
  </Route>,
];
